import component from "./ProfileNewAttention.vue"

import wrapVueComponent from "@/utils/wrapVueComponent"
const componentName = "StudentProfileNewAttention"

export default wrapVueComponent(componentName, component)
